module.exports = __webpack_public_path__ + "img/store_t-shirt-1.596267cf.png";